import React from "react";

import css from "../features_list_page.scss";

type DependsOnCellProps = {
  value: string[] | null;
};

export const DependsOnCell = ({ value }: DependsOnCellProps): JSX.Element => (
  <div className={css.dependsOnRoot}>
    {value &&
      value.map((item) => (
        <span key={item} className={css.dependsOnLabel}>
          {item}
        </span>
      ))}
  </div>
);
